/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Care_Log_Quantity_Hint_BagInputs */

const vi_care_log_quantity_hint_bag = /** @type {(inputs: Care_Log_Quantity_Hint_BagInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`~ ${i?.count} bao`)
};

/**

* @param {Care_Log_Quantity_Hint_BagInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_quantity_hint_bag = /** @type {((inputs: Care_Log_Quantity_Hint_BagInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Quantity_Hint_BagInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_quantity_hint_bag(inputs)
});